import React from 'react'
import styles from './Header.module.css'

export default function Header() {
    return (
        <header className={styles.header}>
            <nav className={styles.gNav}>
                <a className={styles.logo} href='/'>
                    <img
                        src='/pages/business/foodslabo/logo.png'
                        alt='Foodslaboのロゴ'
                    />
                </a>
            </nav>
        </header>
    )
}
